// extracted by mini-css-extract-plugin
export default {"panel_drawer":"styles_panel_drawer__o6Y16"};